export const PUSH_OPT_IN_CAPABILITY_TOKEN = 'PodoPushOptIn/2'
export const PUSH_OPT_IN_STEP_1_UNAVAILABLE_TOKEN = 'PodoPushOptInStep1/Unavailable'
export const DEVICE_PERMISSION_SYNC_CAPABILITY_TOKEN = 'PodoDevicePermissionSync/1'

const hasUserAgentToken = (userAgent: string | null, token: string): boolean =>
  userAgent?.split(/\s+/).includes(token) === true

export const isPushOptInCapableUserAgent = (userAgent: string | null): boolean =>
  userAgent?.includes('PodoApp/RN') === true && hasUserAgentToken(userAgent, PUSH_OPT_IN_CAPABILITY_TOKEN)

export const isPushOptInStep1UnavailableUserAgent = (userAgent: string | null): boolean =>
  isPushOptInCapableUserAgent(userAgent) && hasUserAgentToken(userAgent, PUSH_OPT_IN_STEP_1_UNAVAILABLE_TOKEN)

export const isDevicePermissionSyncCapableUserAgent = (userAgent: string | null): boolean =>
  isPushOptInCapableUserAgent(userAgent) && hasUserAgentToken(userAgent, DEVICE_PERMISSION_SYNC_CAPABILITY_TOKEN)
